import { Typography, Box, Link as MuiLink } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { ContractStatusBadge } from './ContractStatusBadge'
import type { Contract } from '@/types'
import { format } from 'date-fns'
import { ROUTES } from '@/utils/constants'

interface ContractInfoProps {
  contract: Contract
  /** Если true — название группы показываем как текст, без ссылки. */
  disableGroupLink?: boolean
}

export function ContractInfo({ contract, disableGroupLink }: ContractInfoProps) {
  const { t } = useTranslation()

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {t('contracts.status')}
        </Typography>
        <ContractStatusBadge status={contract.status} label={contract.status_label} />
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {t('contracts.startsAt')}
        </Typography>
        <Typography variant="body1">
          {format(new Date(contract.starts_at), 'dd.MM.yyyy')}
        </Typography>
      </Box>

      {contract.expires_at && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {t('contracts.expiresAt')}
          </Typography>
          <Typography variant="body1">
            {format(new Date(contract.expires_at), 'dd.MM.yyyy')}
          </Typography>
        </Box>
      )}

      {contract.group && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {t('contracts.group')}
          </Typography>
          {disableGroupLink ? (
            <Typography variant="body1">{contract.group.name}</Typography>
          ) : (
            <MuiLink
              component={RouterLink}
              to={`${ROUTES.GROUPS}/${contract.group.id}`}
              underline="hover"
              variant="body1"
            >
              {contract.group.name}
            </MuiLink>
          )}
        </Box>
      )}
    </Box>
  )
}
